<div class="flex flex-col">
    <h5 class="pb-2 subtitle" [class.hidden]="!label()">{{ label() }}</h5>
    <span class="body break-all w-fit" [class.hidden]="!text()" [matTooltip]="tooltip() ?? ''">{{ text() }}</span>
    @if (textLines(); as textLines) {
        <div class="flex flex-col">
            @for (line of textLines; track line) {
                <span class="body">{{ line }}</span>
            }
        </div>
    }
</div>
